import React from "react";
import { useLocation } from "react-router-dom";
import Style from "./LanguageSwitcher.module.scss";

export default function LanguageSwitcher() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Determine current language from path only
  const isEnglish = currentPath.startsWith("/en");

  // Handle language toggle
  const handleLanguageToggle = () => {
    const baseUrl = window.location.origin;
    
    if (isEnglish) {
      // If English, switch to Turkish
      let newPath = currentPath.replace("/en", "");
      if (!newPath || newPath === "/") {
        newPath = "/";
      }
      window.location.href = baseUrl + newPath;
    } else {
      // If Turkish, switch to English  
      let newPath;
      if (currentPath === "/") {
        newPath = "/en";
      } else {
        newPath = `/en${currentPath}`;
      }
      window.location.href = baseUrl + newPath;
    }
  };

  return (
    <div className={Style.languageSwitcher} onClick={handleLanguageToggle}>
      {isEnglish ? (
        // If currently in English, show Turkish flag to switch to TR
        <span className="flag-icon flag-icon-tr" title="Türkçe'ye geç" />
      ) : (
        // If currently in Turkish, show US flag to switch to EN
        <span className="flag-icon flag-icon-us" title="Switch to English" />
      )}
    </div>
  );
}
